var ko = require('knockout');
var stringTemplateEngine = require('knockout-template-loader/lib/string-template-engine');
var htmlContent = "<span class=\"mdl-textfield__error\" data-bind=\"click: showValidationError.bind($data, $element, field)\">\r\n    <i class=\"material-icons notranslate\">info</i>\r\n</span>";
ko.templates['validation-error-template-html'] = htmlContent;


//////////////////
// WEBPACK FOOTER
// ./Scripts/Templates/validation-error-template.html
// module id = 43
// module chunks = 0 1 3 5 6 7 9 10 12 13 14 15 16 17 18 19 20